/** Which RFIs and which people Home's overdue RFI row covers, shared by web and native so the two cannot drift. */
import type {RfiRecord} from '../../types/rfis';

// Not clients, not Field-only members. A workspace is required because the row opens that workspace's register.
const RFI_ROLES = new Set(['super_admin', 'internal', 'admin', 'staff', 'workspace_owner', 'workspace_admin']);
export const canReadHomeRfis = (role: string | undefined | null, workspaceId: string | undefined | null): boolean =>
  !!role && !!workspaceId && RFI_ROLES.has(role);

// Only issued RFIs can be overdue.
export function issuedRfis(rows: unknown): RfiRecord[] {
  return Array.isArray(rows) ? (rows as RfiRecord[]).filter((row) => row?.status === 'issued') : [];
}
